import {WfProcessTypeService} from "./service/api/wf-process-type.service";
import {WfProcessTypeStepActivityService} from "./service/api/wf-process-type-step-activity.service";
import {WfProcessService} from "./service/api/wf-process.service";
import {WfProcessStepService} from "./service/api/wf-process-step.service";
import {WfProcessStepCommentService} from "./service/api/wf-process-step-comment.service";
import {WfProcessStepAssignmentLogService} from "./service/api/wf-process-step-assignment-log.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {
    WfProcessConfigOverviewComponent
} from "./component/protected-components/wf-process-config-overview/wf-process-config-overview.component";
import {WfProcessComponent} from "./component/protected-components/wf-process/wf-process.component";
import {WfBpmnDesignerComponent} from "../../feature-core-ext/bpmn-editor/wf-bpmn-designer/wf-bpmn-designer.component";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";

export const WF_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['wf.WfProcessType', {route: '/wf/processTypes', service: WfProcessTypeService, objectComponent: [{viewType: 'designer', component: WfBpmnDesignerComponent}]}],
            ['wf.WfProcessTypeStepReminder', {route: '/wf/processTypeStepReminders'}],
            ['wf.WfProcessTypeStepActivity', {route: '/wf/processTypeStepActivity', service: WfProcessTypeStepActivityService}],
            ['wf.WfActivityTypeObject', {route: '/wf/activityTypes'}],
            ['wf.WfActivityTypeNotification', {route: '/wf/activityTypes'}],
            ['wf.WfActivityTypeStartProcess', {route: '/wf/activityTypes'}],

            ['wf.WfProcess', {route: '/wf/processes', service: WfProcessService, objectComponent: [{mode: MvsCrudModeEnum.update, component: WfProcessComponent}]}],
            ['wf.WfProcessStep', {route: 'wf/processSteps', service: WfProcessStepService}],
            ['wf.WfProcessTypeStepNext', {route: '/wf/wfProcessTypeStepNexts'}],
            ['wf.WfProcessTypeStepActivityFormDefault', {route: '/wf/wfProcessTypeStepActivityFormDefaults'}],

            ['wf.WfReminderType', {route: '/wf/reminderTypes'}],
            ['wf.WfProcessTypeField', {route: '/wf/processTypeFields'}],
            ['wf.WfProcessTypeStep', {route: '/wf/processTypeSteps'}],
            ['wf.WfEventType', {route: '/wf/eventTypes'}],
            ['wf.WfProcessGroup', {route: '/wf/processGroups'}],
            ['wf.WfProcessObject', {route: '/wf/processObjects'}],
            ['wf.WfProcessStepActivity', {route: '/wf/wfProcessStepActivitys'}],
            ['wf.WfProcessField', {route: '/wf/processFields'}],
            ['wf.WfProcessTypeStepEvent', {route: '/wf/processTypeStepEvents'}],
            ['wf.WfProcessTypeStepActivityContext', {route: '/wf/wfProcessTypeStepActivityContexts'}],
            ['wf.WfProcessStepType', {route: '/wf/processStepTypes'}],
            ['wf.WfActivityType', {route: '/wf/activityTypes'}],

            ['wf.WfHintType', {route: '/wf/wfHintTypes'}],
            ['wf.WfProcessTypeStepHint', {route: '/wf/wfProcessTypeStepHints'}],

            ['wf.WfProcessTypeStepActivityTicketCreate', {route: '/wf/wfProcessTypeStepActivityTicketCreates'}],
            ['wf.WfProcessTypeStepActivityNotification', {route: '/wf/wfProcessTypeStepActivityNotifications'}],
            ['wf.WfProcessTypeStepActivityStartProcess', {route: '/wf/wfProcessTypeStepActivityStartProcesss'}],
            ['wf.WfProcessTypeStepActivityObject', {route: '/wf/wfProcessTypeStepActivityObjects'}],
            ['wf.WfProcessStepActivityObject', {route: '/wf/wfProcessStepActivityObjects'}],
            ['wf.WfProcessTypeStepActivityBinding', {route: '/wf/wfProcessTypeStepActivityBindings'}],
            ['wf.WfProcessTypeResult', {route: '/wf/wfProcessTypeResults'}],
            ['wf.WfResultCategory', {route: '/wf/wfResultCategorys'}],
            ['wf.WfProcessTypeStepActivityDocument', {route: '/wf/wfProcessTypeStepActivityDocuments'}],
            ['wf.WfProcessTypeStepActivityChooseNextStep', {route: '/wf/wfProcessTypeStepActivityChooseNextSteps'}],
            ['wf.WfProcessTypeStepActivityTicketStatus', {route: '/wf/wfProcessTypeStepActivityTicketStatuss'}],
            ['wf.WfProcessGroupField', {route: '/wf/wfProcessGroupFields'}],

            ['wf.WfProcessStepComment', {route: '/wf/wfProcessStepComments', service: WfProcessStepCommentService}],
            ['wf.WfProcessStepAssignmentLog', {route: '/wf/wfProcessStepAssignmentLogs', service: WfProcessStepAssignmentLogService}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
